/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import {
  get,
  ref,
  query,
  orderByChild,
  equalTo,
  set,
  remove,
} from "firebase/database";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  CircularProgress,
  Card,
  CardContent,
} from "@mui/material";
import { auth, database } from "../../../firebase";
import UserCreate from "./Users/UserCreate";
import Pagination from "../../Common/Pagination";
import AppLoader from "../../AppLoader";
import { toast } from "react-toastify";
import { deleteUser, getAuth } from "firebase/auth";
import { QRCodeCanvas } from "qrcode.react";
import ReactDOM from "react-dom";
import { useNavigate } from "react-router-dom";
import UserEdit from "./Users/UserEdit";
import { FaUserPlus } from "react-icons/fa";
import CustomPagination from "../../Common/Pagination";
import { Delete, Download, Share } from "@mui/icons-material";
const Users = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [companyId, setCompanyId] = useState("");
  const [page, setPage] = useState(1);
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [confirmDelete, setConfirmDelete] = useState(null);

  const usersPerPage = 10;

  useEffect(() => {
    fetchUserInfo();
    fetchUsers(companyId, page);
    setLoading(true);
  }, [companyId, page]);

  const fetchUserInfo = async () => {
    const currentUser = auth.currentUser;
    if (currentUser) {
      const userRef = ref(database, "users/" + currentUser.uid);
      const snapshot = await get(userRef);
      if (snapshot.exists()) {
        const userData = snapshot.val();
        setCompanyId(userData.companyId);
      }
    }
  };

  const fetchUsers = async (companyId, page) => {
    setLoading(true);
    try {
      const userRef = query(
        ref(database, "users"),
        orderByChild("companyId"),
        equalTo(companyId)
      );
      const snapshot = await get(userRef);
      if (snapshot.exists()) {
        const userlist = snapshot.val();
        const usersData = [];
        for (const key in userlist) {
          // Iterate over object keys
          const user = userlist[key];
          if (user.isActive === true) {
            const profileRef = ref(database, "profiles/" + user.uid);
            const profileSnapshot = await get(profileRef);
            if (profileSnapshot.exists()) {
              const userProfile = profileSnapshot.val();
              const middleNameSegment = userProfile.middleName || "";
              const userName = `${userProfile.firstName}-${
                middleNameSegment ? middleNameSegment + "-" : ""
              }${userProfile.lastName}`;

              user.name =
                `${userProfile.firstName} ${
                  middleNameSegment ? middleNameSegment + " " : ""
                }${userProfile.lastName}` || "Not Active";

              user.qrcode =
                `${window.location.origin}/digitalCard/${
                  userProfile.companyName
                }/${userProfile.firstName}-${
                  middleNameSegment ? middleNameSegment + "-" : ""
                }${userProfile.lastName}` || "Not Active";

              const companyName = userProfile.companyName;

              const scanRef = ref(
                database,
                `digitalCardVisits/${companyName}/${userName}`
              );
              const scanSnapshot = await get(scanRef);
              if (scanSnapshot.exists()) {
                const userScan = scanSnapshot.val();
                user.totalScan = userScan.visitCount || 0;
              }
              usersData.push(user);
            }
          } else {
            user.name = "No Active";
            user.qrcode = "No Active";
            user.totalScan = 0;
          }
        }

        const startIndex = (page - 1) * usersPerPage;
        const paginatedUsers = usersData.slice(
          startIndex,
          startIndex + usersPerPage
        );

        setUsers(paginatedUsers);
      } else {
        setUsers([]);
      }
    } catch (error) {
      console.error("Error fetching users:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleCreateUser = async (email, companyId, role) => {
    try {
      const usersRef = ref(database, "users");
      const snapshot = await get(usersRef);

      let emailExists = false;
      snapshot.forEach((childSnapshot) => {
        const userData = childSnapshot.val();
        if (userData.email === email) {
          emailExists = true;
        }
      });

      if (emailExists) {
        toast.error("Email already exists.");
        return;
      } else {
        await sendEmail(email, companyId, role);
        toast.success("Create Successfully.");
      }
    } catch (error) {
      console.error("Error creating user:", error);
    }
  };
  const sendEmail = async (email, companyId, role) => {
    const emailData = {
      to: email,
      subject: "Welcome to Our Platform",
      text: `Hello, your account has been created successfully. \nYour login details are: \nEmail: ${email}`,
      html: `  <div style="text-align: center; background-color: #007bff; height: 20px; color: white; padding: 10px;">
  <h1 style="font-size: 24px; margin: 0;">Welcome</h1>
</div>
<div style="background-color: white; color: black; padding: 40px; text-align: center;">
        <p style="font-size: 16px; margin: 10px 0;">Your email has been created successfully, but it will only be activated after you set your password.</p>
        <p style="font-size: 16px; margin: 10px 0;"><strong>Email:</strong> ${email}</p>
        <p> <a href="${
          window.location.origin
        }/setUserPassword?email=${encodeURIComponent(
        email
      )}&companyId=${encodeURIComponent(companyId)}&role=${encodeURIComponent(
        role
      )}" style="color: #1E90FF; text-decoration: none; font-weight: bold;">Set your password</a></p>      
      </div>
      <div style="text-align: center; background-color: #007bff; color: white; padding: 10px; margin-top: 10px;">
  <p style="margin: 0; font-size: 14px;">© 2024 Digital Card. All rights reserved.</p>
</div>
    `,
    };

    try {
      const response = await fetch(
        "https://us-central1-md-digital-card.cloudfunctions.net/api/send-email",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(emailData),
        }
      );

      const data = await response.json();

      if (response.ok) {
        console.log("Email sent successfully:", data);
      } else {
        console.error("Error sending email:", data.error);
      }
    } catch (error) {
      console.error("Error sending email:", error);
    }
  };

  const handleEditUser = async (uid, updatedData) => {
    const userRef = ref(database, "users/" + uid);
    await set(userRef, updatedData);
  };

  const handleEditClick = (user) => {
    setSelectedUser(user);
    setShowCreateModal(true);
  };

  const handleCreateClick = () => {
    setSelectedUser(null);
    setShowCreateModal(true);
  };

  const handleDeleteUser = async (uid) => {
    try {
      const auth = getAuth();
      const UserUID = uid;
      const userRef = ref(database, "users/" + uid);
      await remove(userRef);
      const user = await auth.getUser(UserUID);
      if (user) {
        await deleteUser(user);
      }
      fetchUsers(companyId, page);

      toast.success("Deleted Successfully.");
    } catch (error) {
      console.error("Error deleting user:", error);
    }
  };

  const handleDeleteClick = (user) => {
    setConfirmDelete(user);
  };

  const confirmDeleteUser = () => {
    if (confirmDelete) {
      handleDeleteUser(confirmDelete.uid);
      setConfirmDelete(null);
    }
  };

  const cancelDelete = () => {
    setConfirmDelete(null);
  };

  const totalUsers = users.length;
  function formatDateTime(timestamp) {
    const date = new Date(timestamp);

    const options = {
      year: "numeric",
      month: "long", // "January"
      day: "2-digit", // "07"
      hour: "2-digit",
      minute: "2-digit",
      hour12: false, // 12-hour format
    };

    return date.toLocaleString("en-US", options);
  }

  const handleDownloadQRCode = (qrcode) => {
    const sanitizedQRCode = qrcode.replace(/[:/]/g, "-").replace(/\s+/g, "_");

    const container = document.createElement("div");
    container.id = `qrcode-${sanitizedQRCode}`;
    container.style.position = "absolute";
    container.style.visibility = "hidden";

    const qrCodeContainer = document.createElement("div");
    qrCodeContainer.id = "qrcode";
    qrCodeContainer.style.width = "400px";
    qrCodeContainer.style.height = "400px";
    qrCodeContainer.style.backgroundColor = "#ffffff";
    qrCodeContainer.style.textAlign = "center";
    container.appendChild(qrCodeContainer);

    document.body.appendChild(container);

    ReactDOM.render(
      <QRCodeCanvas
        value={qrcode}
        size={300}
        bgColor="#ffffff"
        fgColor="#000000"
        level="H"
        includeMargin={true}
      />,
      qrCodeContainer
    );

    setTimeout(() => {
      const canvas = qrCodeContainer.querySelector("canvas");

      if (canvas) {
        const link = document.createElement("a");
        link.href = canvas.toDataURL("image/jpeg", 1.0);
        link.download = `qrcode-${sanitizedQRCode}.jpg`;
        link.style.display = "none";
        document.body.appendChild(link);

        link.click();
        document.body.removeChild(link);
      } else {
        console.error("Canvas element not found.");
      }
    }, 100);
  };
  const navigate = useNavigate();

  function handleShareQRCode(qrcodeValue) {
    if (navigator.share) {
      navigator
        .share({
          title: "QR Code",
          url: qrcodeValue,
        })
        .catch((error) => console.log("Error sharing", error));
    } else {
      alert("Sharing is not supported on this browser.");
    }
  }
  return (
    <div className="flex flex-col mx-4 px-2 sm:px-8 bg-white rounded-lg h-4/5">
      <Button
        onClick={handleCreateClick}
        variant="contained"
        color="success"
        sx={{
          paddingX: 3,
          paddingY: 1,
          borderRadius: "8px",
          marginBottom: 2,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          alignSelf: "flex-end",
          textTransform: "none", // Prevents uppercase transformation
        }}
      >
        <FaUserPlus style={{ fontSize: "1.2rem", marginRight: "8px" }} />
        Create User
      </Button>
      <UserCreate
        showModal={showCreateModal}
        closeModal={() => setShowCreateModal(false)}
        user={selectedUser}
        handleCreateUser={handleCreateUser}
        handleEditUser={handleEditUser}
      />
      <div>
        <TableContainer component={Paper} className="hidden lg:flex">
          <Table>
            {/* Table Header */}
            <TableHead sx={{ backgroundColor: "#f0f0f0" }}>
              <TableRow>
                <TableCell>Date</TableCell>
                <TableCell>Name</TableCell>
                <TableCell>Total Scan</TableCell>
                <TableCell>QR Code</TableCell>
                <TableCell>Actions</TableCell>
              </TableRow>
            </TableHead>
            {/* Table Body */}
            <TableBody>
              {loading ? (
                <TableRow>
                  <TableCell colSpan={5} align="center">
                    <CircularProgress />
                  </TableCell>
                </TableRow>
              ) : (
                users.map((user, index) => (
                  <TableRow key={index} hover>
                    <TableCell>{formatDateTime(user.createdAt)}</TableCell>
                    <TableCell>{user.name}</TableCell>
                    <TableCell>{user.totalScan}</TableCell>
                    <TableCell>
                      <QRCodeCanvas value={user.qrcode} size={60} />
                    </TableCell>
                    <TableCell>
                      <UserEdit user={user.uid} />
                      <Button
                        onClick={() => handleDeleteClick(user)}
                        variant="contained"
                        color="error"
                        size="small"
                        sx={{ marginRight: 1 }}
                      >
                        <Delete fontSize="small" />
                      </Button>
                      <Button
                        onClick={() => handleDownloadQRCode(user.qrcode)}
                        variant="contained"
                        color="success"
                        size="small"
                        sx={{ marginRight: 1 }}
                      >
                        <Download fontSize="small" />
                      </Button>
                      <Button
                        onClick={() => handleShareQRCode(user.qrcode)}
                        variant="contained"
                        color="warning"
                        size="small"
                      >
                        <Share fontSize="small" />
                      </Button>
                    </TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>

        {/* Grid View for Mobile */}
        <div className="lg:hidden grid grid-cols-2 md:grid-cols-4 gap-4 mt-6">
          {users
            .slice((page - 1) * usersPerPage, page * usersPerPage)
            .map((user) => {
              const createdAt = new Date(user.createdAt);
              const formattedDate = createdAt.toLocaleDateString(); // Extracts date
              const formattedTime = createdAt.toLocaleTimeString(); // Extracts time

              return (
                <Card key={user.id} className="shadow-lg">
                  <CardContent className="text-center">
                    <h3 className="font-semibold">{user.name}</h3>
                    <p className="text-sm text-gray-500">{formattedDate}</p>
                    <p className="text-sm text-gray-500">{formattedTime}</p>
                    <p className="text-sm text-gray-500">
                      Scans: {user.totalScan}
                    </p>
                    <div className="flex justify-center mt-2">
                      <QRCodeCanvas value={user.qrcode} size={100} />
                    </div>
                  </CardContent>
                </Card>
              );
            })}
        </div>
      </div>
      <CustomPagination
        currentPage={page}
        totalItems={totalUsers}
        itemsPerPage={usersPerPage}
        onPageChange={(page) => setPage(page)}
      />
      {confirmDelete && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-white p-8 rounded-lg shadow-md">
            <h2 className="text-xl mb-4">Confirm Deletion</h2>
            <p>Are you sure you want to delete {confirmDelete.name}?</p>
            <div className="flex justify-end mt-6">
              <button
                onClick={confirmDeleteUser}
                className="bg-red-500 text-white px-4 py-2 rounded-lg mr-2"
              >
                Yes
              </button>
              <button
                onClick={cancelDelete}
                className="bg-gray-400 text-white px-4 py-2 rounded-lg"
              >
                No
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Users;
